import { IGoalChildReorderPayload } from "@gtmhub/goals/models";
import { KonvaEventObject, Node, Stage } from "konva/lib/Core";
import { IPosition, IWhiteboardShapeState } from "./shapes";

export type KonvaChangeEventObject<UnderlyingEvent, Value> = KonvaEventObject<UnderlyingEvent> & { oldVal: Value; newVal: Value };

interface WhiteboardEventObjectMap {
  stateChange: { state: IWhiteboardShapeState; changes: Record<string, unknown>; notify?: boolean };
  selectionChange: { selectedShapes: IWhiteboardShapeState[] };
  // the key is needed only for WhiteboardEvent which is keyof WhiteboardEventObjectMap
  scroll: unknown;
  moveViewport: { newViewportPosition: IPosition };
  movedItem: IGoalChildReorderPayload;
  shapeDragEnd: unknown;
  startAutoScrolling: unknown;
  stopAutoScrolling: unknown;
}

export type WhiteboardEvent = keyof WhiteboardEventObjectMap;

export type WhiteboardEventObject<EventType extends WhiteboardEvent, UnderlyingEvent> = KonvaEventObject<UnderlyingEvent> & WhiteboardEventObjectMap[EventType];

const createEvent = <EventType extends WhiteboardEvent, UnderlyingEvent>(
  evt: KonvaEventObject<UnderlyingEvent>,
  target: Node,
  eventArgs: WhiteboardEventObjectMap[EventType]
): WhiteboardEventObject<EventType, UnderlyingEvent> => {
  return Object.assign({}, evt, { target }, eventArgs);
};

export const fireStateEvent = <EventType extends WhiteboardEvent, UnderlyingEvent>(
  eventType: EventType,
  originalEvent: KonvaEventObject<UnderlyingEvent>,
  target: Node,
  eventArgs: WhiteboardEventObjectMap[EventType]
): void => {
  target.getStage().fire(`state-${eventType}`, createEvent(originalEvent, target, eventArgs));
};

export const addStateEventListener = <EventType extends WhiteboardEvent, UnderlyingEvent>(
  stage: Stage,
  eventType: EventType,
  listener: (ev: WhiteboardEventObject<EventType, UnderlyingEvent>) => void
): void => {
  stage.on(`state-${eventType}`, listener);
};
